import { MoreHorizontal } from "lucide-react";
import { Button, MenuContent, MenuItem, MenuRoot, MenuTrigger, cx, useAppNavigate } from "@amber/ui";
import type { QuickAction, TaskRow } from "../../contracts/index";

export function QuickActions({
  task,
  onAction,
  size = "xs",
}: {
  task: TaskRow;
  onAction: (action: QuickAction) => void;
  size?: "xs" | "md";
}) {
  const navigate = useAppNavigate();
  const [first, ...rest] = task.quick_actions;
  if (!first) return <span className="text-muted">—</span>;
  const run = (a: QuickAction) => {
    if (a.kind === "link" && a.href) navigate(a.href);
    else onAction(a);
  };
  const disabled = (a: QuickAction) => (a.availability.enabled ? null : a.availability.reason);
  return (
    <span className={cx("flex items-center gap-1.5", size === "md" && "flex-wrap")}>
      <Button
        size={size}
        variant={size === "md" ? "primary" : "default"}
        disabledReason={disabled(first)}
        onClick={(e) => {
          e.stopPropagation();
          run(first);
        }}
      >
        {first.label}
      </Button>
      {size === "md"
        ? rest.map((a) => (
            <Button
              key={a.key}
              disabledReason={disabled(a)}
              onClick={() => {
                run(a);
              }}
            >
              {a.label}
            </Button>
          ))
        : null}
      {size === "xs" && rest.length > 0 ? (
        <MenuRoot>
          <MenuTrigger
            aria-label={`More actions for ${task.title}`}
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="inline-grid size-6 place-items-center rounded-md border border-border bg-bg text-muted hover:bg-surface-2"
          >
            <MoreHorizontal size={13} aria-hidden="true" />
          </MenuTrigger>
          <MenuContent>
            {rest.map((a) => (
              <MenuItem
                key={a.key}
                disabled={!a.availability.enabled}
                onSelect={() => {
                  run(a);
                }}
              >
                {a.label}
              </MenuItem>
            ))}
          </MenuContent>
        </MenuRoot>
      ) : null}
    </span>
  );
}
